// Import the default export
import DOMPurify from "dompurify";

// Re-export the sanitize method
export const sanitizeHtml = DOMPurify.sanitize;

export { sanitizeUrl } from "@braintree/sanitize-url";
